import React from 'react';
import {Stack, Typography} from '@mui/material';
import {Sx} from 'app/types/common';
import dayjs from 'dayjs';

type Props = Sx & {
  sharedOnly: boolean;
  period?: [number, number];
};

export function NoRecordings({sx, sharedOnly, period}: Props) {
  const renderPeriod = () => {
    if (!period) {
      return '';
    }

    const [start, end] = [dayjs.unix(period[0]), dayjs.unix(period[1])];

    if (start.isSame(end, 'day')) {
      return ` on ${start.format('ll')}`;
    }

    const sameYear = start.isSame(end, 'year');
    const startFmt = start.format('MMM D'.concat(sameYear ? '' : ', YYYY'));

    return ` in period ${startFmt} - ${end.format('ll')}`;
  };

  return (
    <Stack
      sx={sx}
      data-id="no-recordings-card"
      direction="row"
      gap={1}
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h6" color="text.disabled" fontWeight={600}>
        No {sharedOnly ? 'shared' : 'uploaded'} files{renderPeriod()}
      </Typography>
    </Stack>
  );
}
